





import { Component, Prop, Vue } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';

@Component
export default class CalendarList extends Vue {
  // Props
  @Prop({ type: [String, Object], required: true })
  to: RawLocation;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/calendar/link/component.vue